import { EXTERNAL_SHARE } from '@confluence/named-routes/entry-points/routes.ts';
import { CacheConfig } from 'relay-runtime';

/**
 * This function is used to terminate queries with allowOnExternalPage context property
 * if query was fired from external page.
 *
 * @returns true if query should be terminated, false otherwise.
 */
export const shouldTerminateQueriesOnExternalPage = ({
	operationName,
	metadata,
}: {
	operationName: string;
	metadata: CacheConfig['metadata'];
}) => {
	const isExternalShareRequest = !!EXTERNAL_SHARE.match(window.location.pathname);

	const allowOnExternalPage = metadata?.allowOnExternalPage ?? false;
	const shouldTerminate = isExternalShareRequest && !allowOnExternalPage;

	if (shouldTerminate) {
		// eslint-disable-next-line no-console
		console.warn(
			'Trying to make a call on an external route without allowOnExternalPage',
			operationName,
		);
	}

	return shouldTerminate;
};
